export const imports = {
  form: {
    clickOrDrag: 'ここにCSVファイルをドロップしてアップロード',
  },
  pageHeader: {
    title: 'CSV インポート',
    download: 'CSV サンプルのダウンロード',
    importOverWrite: 'インポート（上書き）',
    importInsert: 'インポート（追加）',
  },
}
